<script lang="ts">
  /** Material Symbols "account_tree" icon — branching node tree used for Rules throughout the app */
  let className = '';
  export { className as class };
  export let strokeWidth: number = 1.5;
</script>

<!-- account_tree (Material Symbols) adapted to stroke style -->
<svg
  class={className}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width={strokeWidth}
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  <!-- trunk (bottom center to middle) -->
  <path d="M12 22v-6" />
  <!-- branch point to left -->
  <path d="M12 16H6v-4" />
  <!-- branch point to right -->
  <path d="M12 16h6v-4" />
  <!-- left node -->
  <rect x="3" y="8" width="6" height="4" rx="1" />
  <!-- right node -->
  <rect x="15" y="8" width="6" height="4" rx="1" />
  <!-- center top node -->
  <rect x="9" y="2" width="6" height="4" rx="1" />
  <!-- center trunk up -->
  <path d="M12 6v2" />
  <!-- center to branch split -->
  <path d="M12 8v4" />
</svg>
